import api from "./api";
export type DeletCategoryDto = {
  id: number | string;
};

export const getItemType = async () => {
  return await api.get("/item-types");
};
